<template>
  <div>
    <div class="title">
      <h3>{{title}}</h3>
    </div>
    <b-col class="order" v-if="canOrder">
      <h5>
        Ordenar:&nbsp;&nbsp;
        <b-form-select
          id="orderBy"
          v-model="orderBy"
          :options="orderByOptions"
          @change="changeOrderBy"
        ></b-form-select>
      </h5>
    </b-col>
    <b-row>
      <b-col sm="4" v-for="(property,index) in properties" :key="index">
        <Card :property="property" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Card from "@/components/Card";

export default {
  name: "Carrousel",
  components: {
    Card
  },
  props: {
    title: String,
    properties: Array,
    canOrder: Boolean
  },
  data() {
    return {
      order: "",
      orderBy: "createdAt__desc",
      orderByOptions: [
        { text: "Precio: menor a mayor", value: "ownerPrice__asc" },
        { text: "Precio: mayor a menor", value: "ownerPrice__desc" },
        { text: "Novedad: menor a mayor", value: "createdAt__asc" },
        { text: "Novedad: mayor a menor", value: "createdAt__desc" },
        { text: "Superficie: menor a mayor", value: "area__asc" },
        { text: "Superficie: mayor a menor", value: "area__desc" }
      ]
    };
  },
  methods: {
    changeOrderBy() {
      let orderByAsc = null;
      let orderByDesc = null;

      const [field, order] = this.orderBy.split("__");

      if (order === "asc") {
        orderByAsc = field;
      } else {
        orderByDesc = field;
      }
      this.$router.push({
        name: "search",
        query: {
          ...this.getRouteParams(),
          ...this.$route.query,
          orderByAsc,
          orderByDesc
        }
      });
    },
    getRouteParams() {
      const actualRoute = this.$route.matched.filter(
        ({ path }) => path === this.$route.path
      );
      if (
        actualRoute &&
        actualRoute[0] &&
        actualRoute[0].props &&
        actualRoute[0].props.default &&
        actualRoute[0].props.default.params
      ) {
        return actualRoute[0].props.default.params;
      }
      return {};
    }
  }
};
</script>

<style>
.title {
  text-align: center;
  margin: 50px 0px 30px 0px;
  color: #6e9360;
}
.order {
  text-align: right;
  margin-bottom: 15px;
}
.order select {
  width: auto !important;
  border: none;
  background-color: inherit;
  color: #6e9360;
  cursor: pointer;
  background: none;
}
</style>
